import { Component, Input } from '@angular/core'
import { Price } from '@spartacus/core'

@Component({
  selector: 'mb-submit-order-price',
  templateUrl: './mb-submit-order-price.component.html',
})
export class MbSubmitOrderPriceComponent {

  @Input() requestItemsNo: number | undefined
  @Input() purchaseItemsNo: number | undefined
  @Input() totalPrice: Price | undefined
  @Input() showShippingTaxes = false
  @Input() prices: any | undefined
  @Input() shouldDisplayErpPrices: boolean = false
}
